import { render, staticRenderFns } from "./NewInformation.vue?vue&type=template&id=742fbfa0&scoped=true&lang=html&"
import script from "./NewInformation.vue?vue&type=script&lang=js&"
export * from "./NewInformation.vue?vue&type=script&lang=js&"
import style0 from "./NewInformation.vue?vue&type=style&index=0&id=742fbfa0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742fbfa0",
  null
  
)

export default component.exports